import React, { Component } from 'react';
import styles from './IndustryPage.scss';
import { TransitionGroup } from 'react-transition-group';
import { Fade, OnBoardingNextSkip, IndustryInput } from '@wix/branding-client-lib';

class IndustryPage extends Component {
  render() {
    const { text, getAutocomplete, onIndustrySelect, onNext, onSkip, onTextChanged, nextButtonText, skipButtonText, placeHolderText } = this.props;
    return (
      <div className={styles.container}>
        <TransitionGroup>
          <Fade delay={200} key="1">
            <IndustryInput
              inputStyle="main"
              onIndustryTextChanged={onTextChanged}
              onIndustrySelected={onIndustrySelect}
              industryText={text}
              industriesFetcher={getAutocomplete}
              placeHolderText={placeHolderText}
            />
          </Fade>
          <Fade delay={300} key="2">
            <div className={styles.industryBottomActions}>
              <OnBoardingNextSkip onNext={onNext} onSkip={onSkip} nextText={nextButtonText} skipText={skipButtonText} bng={true} />
            </div>
          </Fade>
        </TransitionGroup>
      </div>
    );
  }
}

export default IndustryPage;
